<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot-scope="scope" slot="menu">
              <el-button
                type="text"
                size="small"
                v-if="permissionList.defaultBtn&&scope.row.isDefault==0"
                @click="setDefault(scope.row)"
              >设置默认
              </el-button>
            </template>
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.invoicesaler_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update,setDefault} from "@/api/v4ward/invoice/invoicesaler";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    labelWidth: 120,
                    searchShow: true,
                    searchMenuSpan: 6,
                    menuWidth: 250,
                    border: true,
                    index: false,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "id",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "名称",
                                    prop: "name",
                                    maxlength: 100,
                                    rules: [{
                                        required: true,
                                        message: "请输入名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "纳税人识别号",
                                    prop: "taxNo",
                                    rules: [{
                                      pattern:/^[0-9]{15,20}$/,
                                      message: '格式错误',
                                    },{
                                        required: true,
                                        message: "请输入纳税人识别号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "地址",
                                    prop: "address",
                                    maxlength: 80,
                                    rules: [{
                                        required: true,
                                        message: "请输入地址",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "电话",
                                    prop: "phone",
                                    rules: [{
                                      pattern:/^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                                      message: '格式错误',
                                    },{
                                        required: true,
                                        message: "请输入电话",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "开户银行",
                                    prop: "bankName",
                                    maxlength: 50,
                                    rules: [{
                                        required: true,
                                        message: "请输入开户银行",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "开户银行账号",
                                    prop: "bankNo",
                                    rules: [{
                                      pattern:/^[0-9]{12,19}$/,
                                      message: '格式错误',
                                    },{
                                        required: true,
                                        message: "请输入开户银行账号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "是否默认",
                                    prop: "isDefault",
                                    type: 'select',
                                    dicData: [
                                        { label: '否', value: '0' },
                                        { label: '是', value: '1' },
                                    ],
                                    addDisplay: false,
                                    editDisplay: false,
                                    rules: [{
                                        required: true,
                                        message: "请选择是否默认",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.invoicesaler_add, false),
                    viewBtn: this.vaildData(this.permission.invoicesaler_view, false),
                    delBtn: this.vaildData(this.permission.invoicesaler_delete, false),
                    editBtn: this.vaildData(this.permission.invoicesaler_edit, false),
                    defaultBtn: this.vaildData(this.permission.invoicesaler_default, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            setDefault(row) {
              this.$confirm("是否设置为默认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  return setDefault({ id: row.id });
                })
                .then(() => {
                  this.onLoad();
                  this.$message.success("操作成功!");
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
